import { Profile } from "@/react/components/Profile/Profile";
import type { CommunityMember } from "@/react/types";
import type { ChatRoom } from "@/react/types/Chat/ChatRoom";
import type { ChatRoomParticipant } from "@/react/types/Chat/ChatRoomParticipant";
import { MemberList } from "./MemberList";

interface ContentProps {
  chatRoom: ChatRoom;
  isDirect: boolean;
  member: CommunityMember;
  otherParticipant: ChatRoomParticipant;
  refetchChatRoom: () => void;
}
export const Content = ({
  chatRoom,
  isDirect,
  refetchChatRoom,
  otherParticipant,
  member,
}: ContentProps) => {
  if (isDirect) {
    return (
      <Profile
        memberPublicId={otherParticipant?.user_public_uid || ""}
        member={member}
        isFullPageProfile={false}
        isRenderedOnRailBar
        shouldHideMessageButton
        shouldHideBadge
        shouldFixTabsOnTop
      />
    );
  }
  return <MemberList chatRoom={chatRoom} refetchChatRoom={refetchChatRoom} />;
};
